export default "__VITE_ASSET__WkeXS43V__"